import React, { useEffect, useState, Fragment } from 'react';
import { motion } from 'framer-motion';
import { AlertCircle } from 'lucide-react';
export function Pricing() {
  // Countdown timer - set to 23h 59m 59s from component mount
  const [timeLeft, setTimeLeft] = useState(() => {
    const saved = typeof window !== 'undefined' ? localStorage.getItem('pricing_countdown_end') : null;
    if (saved) {
      const remaining = Math.max(0, Math.floor((parseInt(saved) - Date.now()) / 1000));
      if (remaining > 0) return remaining;
    }
    // Set 24 hours from now
    const end = Date.now() + 24 * 60 * 60 * 1000;
    if (typeof window !== 'undefined') localStorage.setItem('pricing_countdown_end', end.toString());
    return 24 * 60 * 60;
  });
  useEffect(() => {
    if (timeLeft <= 0) return;
    const interval = setInterval(() => {
      setTimeLeft(prev => {
        if (prev <= 1) {
          clearInterval(interval);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const hours = Math.floor(timeLeft / 3600);
  const minutes = Math.floor(timeLeft % 3600 / 60);
  const seconds = timeLeft % 60;
  const pad = (n: number) => n.toString().padStart(2, '0');
  const cuposPercentage = 68;
  return <section className="w-full bg-[#0a1410] py-8 md:py-16" data-id="element-177">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-178">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} data-id="element-179">
          {/* Urgency Header with Countdown */}
          <div className="text-center mb-6 md:mb-10" data-id="element-180">
            <div className="bg-[#1a0a0a] border border-red-900/40 rounded-2xl p-6 md:p-10 max-w-3xl mx-auto" data-id="element-181">
              <h2 className="text-2xl md:text-4xl font-bold text-white mb-6 md:mb-8" data-id="element-182">
                ⏰ PRECIO DE LANZAMIENTO — CIERRA EN:
              </h2>

              {/* Countdown Timer */}
              <div className="flex items-center justify-center gap-2 md:gap-4 mb-6 md:mb-8" data-id="element-183">
                {[{
                value: pad(hours),
                label: 'HS'
              }, {
                value: pad(minutes),
                label: 'MIN'
              }, {
                value: pad(seconds),
                label: 'SEG'
              }].map((unit, index) => <Fragment key={unit.label} data-id="element-184">
                    {index > 0 && <span className="text-4xl md:text-7xl font-bold text-red-500 -mt-4 md:-mt-6" data-id="element-185">
                        :
                      </span>}
                    <div className="flex flex-col items-center" data-id="element-186">
                      <motion.span key={unit.value} initial={{
                    scale: 1.1,
                    opacity: 0.7
                  }} animate={{
                    scale: 1,
                    opacity: 1
                  }} transition={{
                    duration: 0.2
                  }} className="text-5xl md:text-8xl font-bold text-red-500 tabular-nums leading-none" data-id="element-187">
                        {unit.value}
                      </motion.span>
                      <span className="text-xs md:text-sm text-gray-400 font-medium mt-1 md:mt-2 tracking-widest" data-id="element-188">
                        {unit.label}
                      </span>
                    </div>
                  </Fragment>)}
              </div>

              {/* Warning Text */}
              <div className="flex items-center justify-center gap-2 text-white mb-6 md:mb-8" data-id="element-189">
                <span className="text-lg md:text-xl" data-id="element-190">⚠️</span>
                <p className="text-base md:text-lg font-semibold" data-id="element-191">
                  Después sube{' '}
                  <span className="text-red-500 font-bold" data-id="element-192">$8.000 ARS</span>. No
                  vuelve.
                </p>
              </div>

              {/* Progress Bar - Cupos */}
              <div className="max-w-xl mx-auto" data-id="element-193">
                <div className="flex items-center justify-between mb-2" data-id="element-194">
                  <div className="flex items-center gap-2" data-id="element-195">
                    <span className="w-2.5 h-2.5 rounded-full bg-red-400 animate-pulse" data-id="element-196"></span>
                    <span className="text-sm md:text-base text-red-400 font-medium" data-id="element-197">
                      Cupos al precio de lanzamiento
                    </span>
                  </div>
                  <span className="text-sm md:text-base text-gray-300 font-bold" data-id="element-198">
                    Quedan pocos
                  </span>
                </div>
                <div className="w-full h-3 md:h-4 bg-gray-700 rounded-full overflow-hidden" data-id="element-199">
                  <motion.div initial={{
                  width: 0
                }} whileInView={{
                  width: `${cuposPercentage}%`
                }} viewport={{
                  once: true
                }} transition={{
                  duration: 1.5,
                  ease: 'easeOut'
                }} className="h-full rounded-full" style={{
                  background: 'linear-gradient(90deg, #ef4444 0%, #f97316 70%, #f97316 100%)'
                }} data-id="element-200" />
                </div>
                <p className="text-xs md:text-sm text-gray-500 mt-1.5 text-right" data-id="element-201">
                  {cuposPercentage}% de los cupos al precio de lanzamiento ya
                  tomados
                </p>
              </div>
            </div>
          </div>

          {/* Section Title */}
          <h3 id="elegi-tu-pack" className="text-2xl md:text-3xl font-bold text-white text-center mb-6 md:mb-10 scroll-mt-8" data-id="element-202">
            ELEGÍ TU PACK
          </h3>

          {/* Pricing Cards */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-8 max-w-5xl mx-auto" data-id="element-203">
            {/* Basic Pack */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-[#0f1f17] border border-amber-900/30 rounded-lg p-8" data-id="element-204">
              <h4 className="text-2xl font-bold text-white mb-2" data-id="element-205">
                📘 ATLAS DE LA RODILLA
              </h4>
              <p className="text-amber-500 font-semibold mb-4" data-id="element-206">
                6 Tomos + 3 Bonos
              </p>
              <p className="text-gray-300 text-sm mb-6" data-id="element-207">
                Ideal para profesionales que quieren un sistema completo de
                rodilla
              </p>
              <div className="mb-6" data-id="element-208">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-209">
                  <span className="text-gray-500 line-through text-xl" data-id="element-210">
                    $47.000
                  </span>
                  <span className="text-amber-500 font-bold text-4xl" data-id="element-211">
                    $15.990
                  </span>
                  <span className="text-gray-400" data-id="element-212">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48149627371712:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg px-6 py-4 rounded-lg transition-colors shadow-lg shadow-amber-500/20 text-center" data-id="element-213">
                🔴 → QUIERO MI ATLAS
              </motion.a>
            </motion.div>

            {/* Premium Pack */}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1,
            duration: 0.5
          }} className="bg-[#0f1f17] border-2 border-amber-500 rounded-lg p-8 relative" data-id="element-214">
              <div className="absolute -top-3 left-1/2 -translate-x-1/2 bg-amber-500 text-white text-xs font-bold px-4 py-1 rounded-full" data-id="element-215">
                ⭐ MÁS POPULAR
              </div>
              <h4 className="text-2xl font-bold text-white mb-2" data-id="element-216">
                🏆 ATLAS + MÉTODO BLINDAJE TOTAL
              </h4>
              <p className="text-amber-500 font-semibold mb-4" data-id="element-217">
                6 Tomos + 3 Bonos + Manual Maestro Método Blindaje Total, cadera
                y tobillo
              </p>
              <p className="text-gray-300 text-sm mb-6" data-id="element-218">
                Ideal para: profesionales que trabajan cadena cinética completa
              </p>
              <div className="mb-6" data-id="element-219">
                <div className="flex items-baseline gap-2 mb-2" data-id="element-220">
                  <span className="text-gray-500 line-through text-xl" data-id="element-221">
                    $65.000
                  </span>
                  <span className="text-amber-500 font-bold text-4xl" data-id="element-222">
                    $19.990
                  </span>
                  <span className="text-gray-400" data-id="element-223">ARS</span>
                </div>
              </div>
              <motion.a href="https://www.recursohub.com/cart/48149631860928:1" target="_blank" rel="noopener noreferrer" whileHover={{
              scale: 1.05
            }} whileTap={{
              scale: 0.95
            }} className="block w-full bg-amber-500 hover:bg-amber-600 text-white font-bold text-lg px-6 py-4 rounded-lg transition-colors shadow-lg shadow-amber-500/20 text-center" data-id="element-224">
                🔴 → QUIERO EL ATLAS + BLINDAJE TOTAL
              </motion.a>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>;
}